import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { EmployeeBankAccount, EmployeeBankAccountCreate, EmployeeBankAccountFilter } from '../data/employeeBankAccount';

export function createEmployeeBankAccountService(client: AxiosInstance) {
  return createCrudService<EmployeeBankAccount, EmployeeBankAccountCreate, EmployeeBankAccountFilter>(
    client,
    '/hrm/EmployeeBankAccount',
    'id',
  );
}

export type EmployeeBankAccountService = CrudService<EmployeeBankAccount, EmployeeBankAccountCreate, EmployeeBankAccountFilter>;
